import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const adminRu = {
  appName: 'BuildEX Admin',

  'login.title': 'Вход в админку платформы',
  'login.email': 'Email',
  'login.password': 'Пароль',
  'login.submit': 'Войти',
  'login.error': 'Не удалось войти.',
  logout: 'Выйти',

  'common.cancel': 'Отмена',
  'common.create': 'Создать',
  'common.back': 'Назад',

  'menu.tenants': 'Тенанты',
  'menu.modules': 'Модули',
  'menu.branding': 'Брендинг',
  'menu.users': 'Пользователи',
  'menu.roles': 'Роли',

  'tenants.title': 'Тенанты',
  'tenants.subtitle': 'Компании-клиенты платформы: модули, брендинг, пользователи',
  'tenants.create': 'Новый тенант',
  'tenants.createTitle': 'Новый тенант',
  'tenants.name': 'Компания',
  'tenants.slugLabel': 'Поддомен',
  'tenants.slugHint': 'Строчные латинские буквы, цифры, точки и дефисы',
  'tenants.slug': 'Поддомен',
  'tenants.primaryColor': 'Основной цвет',
  'tenants.status': 'Статус',
  'tenants.modules': 'Модули',
  'tenants.users': 'Пользователи',
  'tenants.active': 'Активен',
  'tenants.blocked': 'Заблокирован',

  'modules.hint':
    'Тумблеры отражают состояние подписки. Фактическая проверка оплаты выполняется на бэкенде; выключенный модуль не загружается браузером тенанта.',

  'branding.title': 'Брендинг',
  'branding.saved': 'Сохранено',
  'branding.primaryColor': 'Основной цвет',
  'branding.primaryColorHint': 'Вся палитра интерфейса генерируется из этого цвета',
  'branding.logoUrl': 'Логотип (URL)',
  'branding.logoUrlHint': 'Загрузка файлов в S3 появится после эндпоинта бэка',
  'branding.radius': 'Скругление углов',
  'branding.font': 'Шрифт',
  'branding.reset': 'Сбросить',
  'branding.save': 'Сохранить',
  'branding.preview': 'Превью кабинета',
  'branding.previewHint':
    'Изменения применяются в превью мгновенно и не видны тенанту до нажатия «Сохранить». Если в превью экран входа — войдите в кабинет в соседней вкладке (localhost:5173), затем обновите страницу.',

  'users.hint': 'Пользователи тенанта и их роли',
  'users.invite': 'Пригласить',
  'users.inviteTitle': 'Приглашение пользователя',
  'users.email': 'Email',
  'users.name': 'Имя',
  'users.role': 'Роль',
  'users.status': 'Статус',
  'users.active': 'Активен',
  'users.invited': 'Приглашён',
  'users.empty': 'Пользователей пока нет',
  'users.send': 'Отправить приглашение',

  'roles.hint':
    'Роль = имя + набор прав. Права собираются из манифестов активных модулей тенанта.',
  'roles.create': 'Новая роль',
  'roles.createTitle': 'Новая роль',
  'roles.name': 'Название роли',
  'roles.all': 'Все права',
  'roles.allHint': 'Полный доступ ко всем модулям (системная роль)',
  'roles.delete': 'Удалить роль',
  'roles.noModules': 'У тенанта нет активных модулей — сначала включите модули на вкладке «Модули».',
};

export function initI18n(): void {
  void i18n.use(initReactI18next).init({
    lng: 'ru',
    fallbackLng: 'ru',
    defaultNS: 'admin',
    ns: ['admin'],
    resources: {
      ru: { admin: adminRu },
    },
    interpolation: { escapeValue: false },
  });
}
